(function () {
  var STORAGE_KEY = 'kp_recent_searches_v1';
  var MAX_SEARCHES = 3;

  function normaliseSearch(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function readSearches() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];

      return parsed
        .map(normaliseSearch)
        .filter(Boolean)
        .slice(0, MAX_SEARCHES);
    } catch (error) {
      return [];
    }
  }

  function writeSearches(searches) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
    } catch (error) {
      // Search remains fully usable when browser storage is unavailable.
    }
  }

  function saveSearch(value) {
    var search = normaliseSearch(value);
    if (!search) return readSearches();

    var searches = readSearches().filter(function (item) {
      return item.toLowerCase() !== search.toLowerCase();
    });

    searches.unshift(search);
    searches = searches.slice(0, MAX_SEARCHES);
    writeSearches(searches);
    return searches;
  }

  function createSearchUrl(path, search) {
    var url = new URL(path || '/search', window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', search);
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  }

  function initialiseDrawer(root) {
    if (root.dataset.kpSearchReady === 'true') return;
    root.dataset.kpSearchReady = 'true';

    var form = root.querySelector('form.search');
    var input = root.querySelector('input[type="search"]');
    var defaults = root.querySelector('[data-kp-search-defaults]');
    var recentSection = root.querySelector('[data-kp-recent-searches]');
    var recentList = root.querySelector('[data-kp-recent-list]');
    var clearButton = root.querySelector('[data-kp-clear-searches]');
    var predictive = root.querySelector('predictive-search');
    var detailModal = root.closest('.detail-modal');

    if (!form || !input || !defaults || !recentSection || !recentList) return;

    function renderSearches(searches) {
      recentList.textContent = '';

      searches.forEach(function (search) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        var removeButton = document.createElement('button');

        item.className = 'kp-search-recent__item';
        link.className = 'kp-search-recent__link';
        link.href = createSearchUrl(root.dataset.searchUrl, search);
        link.textContent = search;
        link.addEventListener('click', function () {
          saveSearch(search);
        });

        removeButton.className = 'kp-search-recent__remove';
        removeButton.type = 'button';
        removeButton.setAttribute('aria-label', 'Remove ' + search + ' from recent searches');
        removeButton.textContent = '×';
        removeButton.addEventListener('click', function () {
          var remainingSearches = readSearches().filter(function (itemSearch) {
            return itemSearch.toLowerCase() !== search.toLowerCase();
          });
          writeSearches(remainingSearches);
          renderSearches(remainingSearches);
        });

        item.appendChild(link);
        item.appendChild(removeButton);
        recentList.appendChild(item);
      });

      recentSection.hidden = searches.length === 0;
    }

    function syncDefaultContent() {
      var hasQuery = normaliseSearch(input.value).length > 0;
      defaults.hidden = hasQuery;

      if (hasQuery && predictive) {
        var results = predictive.querySelector('[data-predictive-search]');
        if (results) results.style.removeProperty('display');
      }
    }

    form.addEventListener('submit', function () {
      var search = normaliseSearch(input.value);
      if (!search) return;
      renderSearches(saveSearch(search));
    });

    input.addEventListener('input', syncDefaultContent);
    input.addEventListener('search', syncDefaultContent);

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        try {
          window.localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
          writeSearches([]);
        }
        renderSearches([]);
      });
    }

    if (detailModal) {
      detailModal.querySelectorAll('.search-modal__close-button, .modal-overlay').forEach(function (control) {
        control.addEventListener('click', function () {
          window.requestAnimationFrame(function () {
            syncDefaultContent();
            renderSearches(readSearches());
          });
        });
      });
    }

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY || event.key === null) {
        renderSearches(readSearches());
      }
    });

    renderSearches(readSearches());
    syncDefaultContent();
  }

  function initialiseAllDrawers() {
    document.querySelectorAll('[data-kp-search-enhancements]').forEach(initialiseDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAllDrawers, { once: true });
  } else {
    initialiseAllDrawers();
  }

  document.addEventListener('shopify:section:load', initialiseAllDrawers);
})();
